import { jsx as _jsx } from "react/jsx-runtime";
import { Datepicker, Page, setOptions } from '@mobiscroll/react';
import '@mobiscroll/react/dist/css/mobiscroll.scss';
setOptions({
    theme: 'material',
    themeVariant: 'light'
});
export function Calendar({ date, setDate }) {
    const handleSetDate = (e) => {
        setDate(e.date);
    };
    return (_jsx(Page, { children: _jsx(Datepicker, { controls: ['calendar'], display: 'inline', min: new Date(), firstDay: 1, value: date, onCellClick: handleSetDate, defaultSelection: null }) }));
}
